import type { FileReviewPanelPlacement } from '@jarvis/platform-file-review';
import { truncateDisplayTitle } from './displayTitle';
import './MediaViewerTitle.css';

export type MediaViewerKind = 'pdf' | 'spreadsheet' | 'word';

const ICON_BY_KIND: Record<Exclude<MediaViewerKind, 'spreadsheet'>, string> = {
  pdf: 'exportpdf',
  word: 'doc'
};

export interface MediaViewerTitleProps {
  kind: MediaViewerKind;
  title: string;
  path?: string;
  discussionExpanded: boolean;
  placement: FileReviewPanelPlacement;
  /** When omitted, discussion toggle is hidden (e.g. Public folder). */
  onDiscussionToggle?: () => void;
  className?: string;
}

export function MediaViewerTitle({
  kind,
  title,
  path,
  discussionExpanded,
  placement,
  onDiscussionToggle,
  className = ''
}: MediaViewerTitleProps) {
  const panelActive = placement !== 'off' && discussionExpanded;
  const actionLabel =
    panelActive ? 'Close discussion' : 'Open discussion';
  const fullTitle = title.trim();
  const displayTitle = truncateDisplayTitle(fullTitle);
  const discussionsEnabled = typeof onDiscussionToggle === 'function';

  return (
    <span className={`media-viewer-title ${className}`.trim()}>
      {discussionsEnabled ? (
        <button
          type="button"
          className={`media-viewer-title__icon-btn${panelActive ? ' media-viewer-title__icon-btn--active' : ''}`}
          onClick={onDiscussionToggle}
          title={actionLabel}
          aria-label={actionLabel}
          aria-expanded={panelActive}
        >
          <span
            className={
              kind === 'spreadsheet'
                ? 'media-viewer-title__spreadsheet-grid'
                : `dx-icon dx-icon-${ICON_BY_KIND[kind]}`
            }
            aria-hidden="true"
          />
        </button>
      ) : (
        <span className="media-viewer-title__icon-btn media-viewer-title__icon-btn--static" aria-hidden="true">
          <span
            className={
              kind === 'spreadsheet'
                ? 'media-viewer-title__spreadsheet-grid'
                : `dx-icon dx-icon-${ICON_BY_KIND[kind]}`
            }
            aria-hidden="true"
          />
        </span>
      )}
      <span className="media-viewer-title__text" title={fullTitle || path || undefined}>
        {displayTitle}
      </span>
    </span>
  );
}
